/* eslint-disable */ 
import React, { Component } from 'react';
import { Tabs, Tab, Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { divisionTeamPowerPointsFilter,divisionTeamPowerPointsCombinedFilter } from '../../../utils/functions';
import { DIVISIONS,TIERS,TeamPowerPointHeaders } from '../../../utils/constants';
import  Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getTeamPowerPointsBySeason } from '../api'
import { exportCSV,getNum } from '../common'
export default class TeamPowerPointsPage extends Component  {

    constructor(props) {
        super(props);
        const { match } = this.props
        this.state = {
          rankingSeason:[],
          teamPowerPointsAll:[],
          seasonId:match.params.seasonId,
          teamId: match.params.teamId,
          weekNo: match.params.weekNo,
          currentSeason: '',
          team: match.params.teamName,
          thruweekText: ''          
        };
 
      }

  eventNameFormatter(cell, row) {
    var linkMen = `/teamStandings/${row.seasonId}/${row.eventId}/${row.tevent}/${row.seasonName}/true`;
    var linkWomen = `/teamStandings/${row.seasonId}/${row.eventId}/${row.tevent}/${row.seasonName}/false`;
     return (
            <div >
            { (row.division==='M')
              ? <Link className="cellLinksLeft" to={linkMen}>{row.tevent}</Link>
              : <Link className="cellLinksLeft" to={linkWomen}>{row.tevent}</Link>
            }            
        </div>            
           );     
  }  

  componentDidMount() {
    const _this = this
    getTeamPowerPointsBySeason(_this.state.seasonId,_this.state.teamId,_this.state.weekNo).then(function(response) {
       _this.setState({teamPowerPointsAll: response.data.teamPowerPoints})
       _this.setState({rankingSeason: response.data.rankingSeason})
       _this.setState({thruweekText: 'Team Power Points thru week '+_this.state.weekNo}) 
   })    
  }    

  totals_Tier1PowerPoints_Row(tabData) {
    var totSum = tabData.reduce( function(cnt,i){ return cnt + i.total; },0);    
    return <tr >
              <td>Tier I Power Points</td>
              <td>{getNum(totSum)}</td>
          </tr>
  }

  totals_Tier1Events_Row(tabData) {
  var totCnt = tabData.filter( item => item.total > 0).length;    
    return <tr>
              <td>Tier I Events</td>
              <td>{getNum(totCnt)}</td>
            </tr>   
  }  

  totals_Tier2PowerPoints_Row(tabData) {
    var totSum = tabData.reduce( function(cnt,i){ return cnt + i.total; },0);    
    return <tr>
              <td>Tier II Power Points</td>
              <td>{getNum(totSum)}</td>
          </tr>
  }

  totals_Tier2Events_Row(tabData) {
    var totCnt = tabData.filter(item => item.total > 0).length;
    return <tr>
              <td>Tier II Events</td>
              <td>{getNum(totCnt)}</td>
            </tr>   
  } 

  totals_TotalPowerPoints_Row(tier1Data, tier2Data) {
    var totTier1Sum = tier1Data.reduce(function (cnt, i) { return cnt + i.total; }, 0);
    var totTier2Sum = tier2Data.reduce(function (cnt, i) { return cnt + i.total; }, 0);
    var totSum = totTier1Sum + totTier2Sum;
    return <tr >
      <td>TOTAL: Power Points</td>
      <td>{getNum(totSum)}</td>
    </tr>
  }

  totals_TotalEvents_Row(tier1Data,tier2Data) {
    var tier1DataEvents = tier1Data.filter(item => item.total >0 ).length;
    var tier2DataEvents = tier2Data.filter(item => item.total >0 ).length;   
    var totEvents = tier1DataEvents + tier2DataEvents;
    return  <tr>
              <td>TOTAL: Events</td>
              <td>{getNum(totEvents)}</td>
            </tr>               
  }

  avg_PowerPointsPerEvent_Row(tier1Data,tier2Data) {
    const _this = this;
    var totalGameMaxThreshold =_this.state.rankingSeason.totalGameMaxThreshold; 
    var totTier1Sum = tier1Data.reduce( function(cnt,i){ return cnt + i.total; },0);    
    var totTier2Sum = tier2Data.reduce( function(cnt,i){ return cnt + i.total; },0);   
    var tier1DataEvents = tier1Data.filter(item => item.total >0 ).length;
    var tier2DataEvents = tier2Data.filter(item => item.total >0 ).length;   
    var totSum = totTier1Sum+totTier2Sum;
    var totEvents = tier1DataEvents + tier2DataEvents;
    var avgPowerPointsPerEvent = totSum / totEvents;
    var adjustedTotalPowerPoints=this.getAdjustedTotalPowerPoints(tier1Data,tier2Data);
    
    var adjEvents =(tier1Data.filter(item => item.total >0 ).length + tier2Data.filter(item => item.total >0 ).length);
    adjEvents = adjEvents > totalGameMaxThreshold ? totalGameMaxThreshold : adjEvents;
    var pwrPointAvg = (adjustedTotalPowerPoints) / (adjEvents);

    if (totEvents > totalGameMaxThreshold) {
      avgPowerPointsPerEvent = pwrPointAvg
    }

        
    return  <tr >
                <td>AVERAGE: Power Points Per Event</td>
                <td>{getNum(Math.floor(avgPowerPointsPerEvent))}</td>
                {/* <td>{getNum(Math.floor(pwrPointAvg))}</td> */}
            </tr>     
  }

  power_RankingFormula_Row(tier1Data,tier2Data) {
    const _this = this;
    var totalGameMaxThreshold =_this.state.rankingSeason.totalGameMaxThreshold;
    var eventFactor =_this.state.rankingSeason.eventFactor;
    var adjEvents =(tier1Data.filter(item => item.total >0 ).length + tier2Data.filter(item => item.total >0 ).length);
    var adjustedTotalPowerPoints=this.getAdjustedTotalPowerPoints(tier1Data,tier2Data);
    adjEvents = adjEvents > totalGameMaxThreshold ? totalGameMaxThreshold : adjEvents;
    var pwrPointAvg = (adjustedTotalPowerPoints) /(adjEvents);    
    
    var tier1DataEvents = tier1Data.filter(item => item.total >0 ).length;
    var tier2DataEvents = tier2Data.filter(item => item.total >0 ).length;   
    var totEvents = tier1DataEvents + tier2DataEvents;
    
    
    var pr = totEvents > 1 ? ( eventFactor * getNum(Math.floor(pwrPointAvg)) ) +( 2 * getNum(Math.floor(adjustedTotalPowerPoints)) )
                           : ( eventFactor * getNum(Math.floor(pwrPointAvg)) );
    var totalPwrPntsMsg = totEvents > 1 ? "+ ( 2 x "+getNum(Math.floor(adjustedTotalPowerPoints))+" )": " ";
    return  <tr >
              <td>POWER RANKING FORMULA:</td>
              <td>( {eventFactor} x {getNum(Math.floor(pwrPointAvg))} ) {totalPwrPntsMsg} = {(pr).toFixed(0)}</td> 
            </tr>  
  }

  event_Exceed5Limit_Rows(tier1Data,tier2Data) {
    const _this = this;
    var totalGameMaxThreshold =_this.state.rankingSeason.totalGameMaxThreshold;
    var tierOneGameMaxThreshold =_this.state.rankingSeason.tierOneGameMaxThreshold;    
    var T1Exceed5 = "No";
    var adjustedTier1Points = 0;
    var adjustedTier2Points = 0;
    var adjustedTier1Events = 0;
    var totTier1Sum = tier1Data.reduce( function(cnt,i){ return cnt + i.total; },0); 
    var totTier2Sum = tier2Data.reduce( function(cnt,i){ return cnt + i.total; },0); 

     if (tier1Data.length > tierOneGameMaxThreshold  ) {
        T1Exceed5 ="Yes";       
        adjustedTier1Events = tierOneGameMaxThreshold; 
        adjustedTier1Points = (totTier1Sum/tier1Data.length ) * adjustedTier1Events;
        
        if (tier2Data.length > tierOneGameMaxThreshold) {          
          adjustedTier2Points = (totTier2Sum/tier2Data.length ) * adjustedTier1Events;
        }
        else {
          adjustedTier2Points = (totTier2Sum/tier2Data.length );
        }

     }     
     else {
       const maximumT2Events = ( totalGameMaxThreshold - tier1Data.length );
       adjustedTier1Points = 0 ;

       if (tier2Data.length > maximumT2Events) {
        adjustedTier2Points = (totTier2Sum/tier2Data.length ) * maximumT2Events;
       } 
       else {
        adjustedTier2Points = (totTier2Sum/tier2Data.length ) ;
       }
     }
    
    return <React.Fragment>
                          <tr className="table_greybackground">
                            <td>Do Tier 1 Events exceed limit ({tierOneGameMaxThreshold})?</td>
                            <td>{T1Exceed5}</td>                          
                          </tr>                   
                          <tr className="table_greybackground">
                            <td>ADJUSTED: Tier 1 Points</td>
                            <td>{getNum(Math.floor(adjustedTier1Points))}</td>                          
                          </tr>                   
                          <tr className="table_greybackground">
                            <td>ADJUSTED: Tier 1 Events</td>
                            <td>{getNum(Math.floor(adjustedTier1Events))}</td>                          
                          </tr>       
            </React.Fragment>
  }

  event_Exceed10Limit_Rows(tier1Data,tier2Data) {
    const _this = this;
    var totalGameMaxThreshold =_this.state.rankingSeason.totalGameMaxThreshold;
    var T1Exceed10 = "No";
    // var T1Exceed5 = "No"
    var totItemsCount = 0;
    var adjustedTotalEvents = 0;
    var adjustedTotalPowerPoints = 0;
    var tier1DataEvents = tier1Data.filter(item => item.total >0 ).length;
    var tier2DataEvents = tier2Data.filter(item => item.total >0 ).length;  
    
    if (tier1DataEvents >= 0 || tier2DataEvents >=0) {      
      totItemsCount = tier1DataEvents + tier2DataEvents;
      
      if ( totItemsCount > totalGameMaxThreshold ) {
        T1Exceed10="Yes";
        adjustedTotalEvents = totalGameMaxThreshold;
        adjustedTotalPowerPoints=this.getAdjustedTotalPowerPoints(tier1Data,tier2Data);
      }
      else {

      }
    } 
        
    return <React.Fragment>
                          <tr className="table_greybackground">
                            <td>Do Total Events exceed limit ({totalGameMaxThreshold})?</td>
                            <td>{T1Exceed10}</td>                          
                          </tr>                   
                          <tr className="table_greybackground">
                            <td>ADJUSTED: Total Power Points</td>
                            <td>{getNum(Math.floor(adjustedTotalPowerPoints))}</td>
                          </tr>                   
                          <tr className="table_greybackground">
                            <td>ADJUSTED: Total Events</td>
                            <td>{getNum(Math.floor(adjustedTotalEvents))}</td>                          
                          </tr>       
            </React.Fragment>
  }
  getAdjustedTotalPowerPoints(tier1Data,tier2Data) {
    const _this = this;
    var totalGameMaxThreshold =_this.state.rankingSeason.totalGameMaxThreshold; 
    var tierOneGameMaxThreshold =_this.state.rankingSeason.tierOneGameMaxThreshold;
    var adjustedTotalPowerPoints=0;
    var tier1DataEvents = tier1Data.filter(item => item.total >0 ).length;
    var tier2DataEvents = tier2Data.filter(item => item.total >0 ).length;    
    var adjustedTier1Points = 0;
    var adjustedTier2Points = 0;
    var adjustedTier1Events = tier1DataEvents > tierOneGameMaxThreshold ? tierOneGameMaxThreshold: tier1DataEvents;
    var adjustedTier2Events = (tier1DataEvents+tier2DataEvents) > totalGameMaxThreshold ? totalGameMaxThreshold - adjustedTier1Events: tier2DataEvents;
    var totTier1Sum = tier1Data.reduce( function(cnt,i){ return cnt + (i.total>0 ? i.total: 0); },0); 
    var totTier2Sum = tier2Data.reduce( function(cnt,i){ return cnt + (i.total>0 ? i.total: 0); },0); 
    adjustedTier1Points = getNum((totTier1Sum/tier1DataEvents ) * adjustedTier1Events);     
    adjustedTier2Points = getNum((totTier2Sum/tier2DataEvents ) * adjustedTier2Events);
    adjustedTotalPowerPoints=adjustedTier1Points+adjustedTier2Points;

     return  adjustedTotalPowerPoints;
  }
  render() {
    const _this = this
    const { match } = this.props

    var teamDivisionMen = match.params.teamDivisionMen

     var defaultTab = DIVISIONS.MENTAB;;
     if (teamDivisionMen === 'False') {
       defaultTab = DIVISIONS.WOMENTAB;
     }    
    const teamPowerPointsAll = _this.state.teamPowerPointsAll
    const menDivT1TeamPowerPoints = teamPowerPointsAll
    .filter((powerPoints) => divisionTeamPowerPointsFilter(powerPoints, DIVISIONS.MEN,TIERS.ONE));  
    const menDivT2TeamPowerPoints = teamPowerPointsAll
    .filter((powerPoints) => divisionTeamPowerPointsFilter(powerPoints, DIVISIONS.MEN,TIERS.TWO));  
    const womenDivT1TeamPowerPoints = teamPowerPointsAll
    .filter((powerPoints) => divisionTeamPowerPointsFilter(powerPoints, DIVISIONS.WOMEN,TIERS.ONE));    
    const womenDivT2TeamPowerPoints = teamPowerPointsAll
    .filter((powerPoints) => divisionTeamPowerPointsFilter(powerPoints, DIVISIONS.WOMEN,TIERS.TWO));    
    const exportMenDiv = teamPowerPointsAll
    .filter((powerPoints) => divisionTeamPowerPointsCombinedFilter(powerPoints, DIVISIONS.MEN));  
    const exportWomenDiv =teamPowerPointsAll
    .filter((powerPoints) => divisionTeamPowerPointsCombinedFilter(powerPoints, DIVISIONS.WOMEN));  
    
    return (
    <div>
      <Navwrapper />
      <div className="container-fluid">
        <Row>
          <Col xs={12}>
            <div className="pageHeading" >
                <h4>{_this.state.currentSeason}</h4>
                  <h4 >
                        {_this.state.team}<br/>
                        <label> {_this.state.thruweekText}</label>
                  </h4>
            </div>      
          </Col>
        </Row>

        <Row>
          <Col xs={12}>      
            <Tabs defaultActiveKey={ defaultTab } id="team-powerPoints-tabs">
              <Tab eventKey={1} title="MEN">           
                    <BootstrapTable 
                      data={menDivT1TeamPowerPoints} 
                      striped 
                      hover 
                      options={{ hideSizePerPage: true }}
                      pagination={false}               
                    >
                        <TableHeaderColumn          
                          dataField="Id" 
                          isKey 
                          dataAlign="right" 
                          dataSort 
                          data-Visible="false"               
                          hidden                 
                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="tno" dataSort width="2%" >T1#
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="fin" 
                          dataSort  
                          width="2%" 
                        >FIN
                        </TableHeaderColumn>   
                        <TableHeaderColumn dataField="tms" dataAlign="right"  width="2%" >TMS
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="tevent" 
                          dataSort 
                          dataAlign="left" 
                          dataFormat={this.eventNameFormatter} 
                          width="15%" 
                        >Tier 1 EVENTS
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="bpts" dataAlign="right"  width="2%" >BPts
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="tpts" dataAlign="right"  width="2%" >TPts
                        </TableHeaderColumn>                                    
                        <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >Total
                        </TableHeaderColumn>                  
                    </BootstrapTable>     

                    <Row className="blank_row" />    
                    <Row className="blank_row" />                        

                    <BootstrapTable 
                      data={menDivT2TeamPowerPoints} 
                      striped 
                      hover 
                      options={{ hideSizePerPage: true }}
                      pagination={false}               
                    >
                        <TableHeaderColumn          
                          dataField="Id" 
                          isKey 
                          dataAlign="right" 
                          dataSort 
                          data-Visible="false"               
                          hidden                 
                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="tno" dataSort width="2%" >T2
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="fin" 
                          dataSort  
                          width="2%" 
                        >FIN
                        </TableHeaderColumn>   
                        <TableHeaderColumn dataField="tms" dataAlign="right"  width="2%" >TMS
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="tevent" 
                          dataSort 
                          dataAlign="left" 
                          dataFormat={this.eventNameFormatter}  
                          width="15%" 
                        >Tier 2 EVENTS
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="bpts" dataAlign="right"  width="2%" >BPts
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="tpts" dataAlign="right"  width="2%" >TPts
                        </TableHeaderColumn>                                    
                        <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >Total
                        </TableHeaderColumn>                  
                    </BootstrapTable>                       

                    <Row className="blank_row" />
                    { exportCSV(exportMenDiv,TeamPowerPointHeaders,'MenDivTeamPowerPoints - '+_this.state.team+'.csv') }                    
                    <Row> 
                      <Col xs={3} /> 
                      <Col xs={6}className="pageHeading" >POWER RANKING CALCULATION</Col>
                      <Col xs={3} />
                    </Row>   
                    <Row >
                      <Col xs={3} />
                      <Col xs={6}>                                                
                        <Table className="totals_table"  >
                          <thead >
                            <tr >
                              <th/>
                              <th/>
                            </tr>
                          </thead>
                          <tbody>
                            { this.totals_Tier1PowerPoints_Row(menDivT1TeamPowerPoints)}
                            { this.totals_Tier1Events_Row(menDivT1TeamPowerPoints)}
                            { this.event_Exceed5Limit_Rows(menDivT1TeamPowerPoints,menDivT2TeamPowerPoints)}
                            { this.totals_Tier2PowerPoints_Row(menDivT2TeamPowerPoints)}
                            { this.totals_Tier2Events_Row(menDivT2TeamPowerPoints)}
                            { this.totals_TotalPowerPoints_Row(menDivT1TeamPowerPoints,menDivT2TeamPowerPoints) }
                            { this.totals_TotalEvents_Row(menDivT1TeamPowerPoints,menDivT2TeamPowerPoints)}
                            { this.event_Exceed10Limit_Rows(menDivT1TeamPowerPoints,menDivT2TeamPowerPoints)}
                            { this.avg_PowerPointsPerEvent_Row(menDivT1TeamPowerPoints,menDivT2TeamPowerPoints) }
                            { this.power_RankingFormula_Row(menDivT1TeamPowerPoints,menDivT2TeamPowerPoints) }
                          </tbody>
                        </Table>
                      </Col>
                    </Row>

                </Tab>
              <Tab eventKey={2} title="WOMEN">
                <BootstrapTable 
                  data={womenDivT1TeamPowerPoints} 
                  striped 
                  hover     
                  options={{ hideSizePerPage: true }} 
                  pagination={true} 
                >
                        <TableHeaderColumn          
                          dataField="Id" 
                          isKey 
                          dataAlign="right" 
                          dataSort 
                          data-Visible="false"               
                          hidden                 
                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="tno" dataSort width="2%" >T1#
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="fin" 
                          dataSort  
                          width="2%" 
                        >FIN
                        </TableHeaderColumn>   
                        <TableHeaderColumn dataField="tms" dataAlign="right"  width="2%" >TMS
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="tevent" 
                          dataSort 
                          dataAlign="left" 
                          dataFormat={this.eventNameFormatter}  
                          width="15%" 
                        >Tier 1 EVENTS
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="bpts" dataAlign="right"  width="2%" >BPts
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="tpts" dataAlign="right"  width="2%" >TPts
                        </TableHeaderColumn>                                    
                        <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >Total
                        </TableHeaderColumn>                                        
                </BootstrapTable>

                    <Row className="blank_row" />    

                <BootstrapTable 
                  data={womenDivT2TeamPowerPoints} 
                  striped 
                  hover 
                  // options={tableOptions}
                  options={{ hideSizePerPage: true }} 
                  pagination={true} 
                >
                        <TableHeaderColumn          
                          dataField="Id" 
                          isKey 
                          dataAlign="right" 
                          dataSort 
                          data-Visible="false"               
                          hidden                 
                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="tno" dataSort width="2%" >T2
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="fin" 
                          dataSort  
                          width="2%" 
                        >FIN
                        </TableHeaderColumn>   
                        <TableHeaderColumn dataField="tms" dataAlign="right"  width="2%" >TMS
                        </TableHeaderColumn>
                        <TableHeaderColumn 
                          dataField="tevent" 
                          dataAlign="left" 
                          dataFormat={this.eventNameFormatter} 
                          width="15%" 
                        >Tier 2 EVENTS
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="bpts" dataAlign="right"  width="2%" >BPts
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField="tpts" dataAlign="right"  width="2%" >TPts
                        </TableHeaderColumn>                                    
                        <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >Total
                        </TableHeaderColumn>                                        
                </BootstrapTable>             

                    <Row className="blank_row" />
                    { exportCSV(exportWomenDiv,TeamPowerPointHeaders,'WomenDivTeamPowerPoints - '+_this.state.team+'.csv') }

                <Row> 
                  <Col xs={3} /> 
                  <Col xs={6}className="pageHeading" >POWER RANKING CALCULATION</Col>
                  <Col xs={3} />
                </Row>   
                <Row >
                  <Col xs={3} />
                  <Col xs={6}>                                                
                    <Table className="totals_table"  >
                      <thead >
                        <tr >
                          <th/>
                          <th/>
                        </tr>
                      </thead>
                      <tbody>
                          { this.totals_Tier1PowerPoints_Row(womenDivT1TeamPowerPoints)}
                          { this.totals_Tier1Events_Row(womenDivT1TeamPowerPoints)}                        
                          { this.event_Exceed5Limit_Rows(womenDivT1TeamPowerPoints,womenDivT2TeamPowerPoints)}
                          { this.totals_Tier2PowerPoints_Row(womenDivT2TeamPowerPoints)}
                          { this.totals_Tier2Events_Row(womenDivT2TeamPowerPoints)}                       
                          { this.totals_TotalPowerPoints_Row(womenDivT1TeamPowerPoints,womenDivT2TeamPowerPoints) }
                          { this.totals_TotalEvents_Row(womenDivT1TeamPowerPoints,womenDivT2TeamPowerPoints)}
                          { this.event_Exceed10Limit_Rows(womenDivT1TeamPowerPoints,womenDivT2TeamPowerPoints)}
                          {/* <tr className="table_greybackground">
                            <td>Do Total Events exceed limit (10)?</td>
                            <td>No</td>                          
                          </tr>                   
                          <tr className="table_greybackground">
                            <td>ADJUSTED: Total Power Points</td>
                            <td>0</td>                          
                          </tr>                   
                          <tr className="table_greybackground">
                            <td>ADJUSTED: Total Events Events</td>
                            <td>0</td>                          
                          </tr>  */}
                          { this.avg_PowerPointsPerEvent_Row(womenDivT1TeamPowerPoints,womenDivT2TeamPowerPoints) }
                          { this.power_RankingFormula_Row(womenDivT1TeamPowerPoints,womenDivT2TeamPowerPoints) }
                      </tbody>
                    </Table>
                  </Col>
                </Row>             

              </Tab>
            </Tabs>
          </Col>
        </Row>
        <Row className="blank_row" />
        <Row className="blank_row" />      
      
      </div>
      <Footer />
    </div>    
    )  
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/teamPowerPoints/index.js